export default __webpack_public_path__ + "static/media/nebulae.e32eaeb4.png";